import React, { useContext, useEffect } from "react";
import Hero from "../Components/Home/Hero";
import Services from "../Components/Home/Services";
import { AppContext } from "../Contexts/AppContext";

const Home = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "default");
    context.setCurrent("default");
  }, [context]);
  return (
    <div>
      <Hero />
      <Services />
    </div>
  );
};

export default Home;
